import { render } from "./DocumentTableView.vue?vue&type=template&id=65af4614&lang=true"
import script from "./DocumentTableView.vue?vue&type=script&lang=js"
export * from "./DocumentTableView.vue?vue&type=script&lang=js"

import "./DocumentTableView.vue?vue&type=style&index=0&id=65af4614&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__